import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { Toaster } from "react-hot-toast";
import { useScreenSize, useCustomScreen } from "../Utils";
export default function Layout() {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  return (
    <div className="">
      <Header />
      <div>
        <Outlet />
      </div>
      <Footer />
      <Toaster
        position={isSmallScreen ? "top-center" : "top-right"}
        containerStyle={{
          top: "80px", // Adjust based on your header height
        }}
      />
    </div>
  );
}
